export default __webpack_public_path__ + "static/photo2-83ad7794200b9338d50e393e9a93827d.jpg";